import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);
import Menu from "../views/MainMenu.vue";
import Home from "../views/Home.vue";
import ITConsultancy from "@/views/services/ITConsultancy.vue";
import SwDevelopment from "@/views/services/SwDevelopment.vue";
import CloudServices from "@/views/services/CloudServices.vue";
import ContactUs from "../views/contactUs/ContactUs.vue";
import FormSuccess from "@/views/contactUs/FormSuccess.vue";
import FormError from "@/views/contactUs/FormError.vue";
import OurExperience from "@/views/ourWork/OurExperience.vue";
import OurSkills from "@/views/ourWork/OurSkills.vue";
import AboutToucan from "@/views/aboutUs/AboutToucan.vue";
import SendCV from "@/views/aboutUs/SendCV.vue";
import JoinUs from "@/views/aboutUs/JoinUs.vue";
import NotFound from "@/views/NotFound.vue";

const routes: Array<RouteConfig> = [
  {
    path: "/",
    redirect: "/home",
    name: "Menu",
    component: Menu,
    meta: {
      public: true,
    },
    children: [
      /**
       * Home
       */
      {
        path: "/home",
        name: "Home",
        component: Home,
        meta: {
          public: true,
        },
      },
      /**
       * Services
       */
      {
        path: "/services/it-consultancy",
        name: "ITConsultancy",
        component: ITConsultancy,
        meta: {
          public: true,
        },
      },
      {
        path: "/services/sw-development",
        name: "SwDevelopment",
        component: SwDevelopment,
        meta: {
          public: true,
        },
      },
      {
        path: "/services/cloud-services",
        name: "CloudServices",
        component: CloudServices,
        meta: {
          public: true,
        },
      },
      /**
       * Our Work
       */
      {
        path: "/our-work/experiences",
        name: "OurExperience",
        component: OurExperience,
        meta: {
          public: true,
        },
      },
      {
        path: "/our-work/skills",
        name: "OurSkills",
        component: OurSkills,
        meta: {
          public: true,
        },
      },
      /**
       * About Us
       */
      {
        path: "/about-us/toucan",
        name: "AboutToucan",
        component: AboutToucan,
        meta: {
          public: true,
        },
      },
      {
        path: "/about-us/join-us",
        name: "JoinUs",
        component: JoinUs,
        meta: {
          public: true,
        },
      },
      {
        path: "/about-us/your-cv",
        name: "SendCV",
        component: SendCV,
        meta: {
          public: true,
        },
      },
      /**
       * Contact Us
       */
      {
        path: "/contact-us",
        name: "ContactUs",
        component: ContactUs,
        meta: {
          public: true,
        },
      },
      {
        path: "/success",
        name: "success",
        component: FormSuccess,
        meta: {
          public: false,
        },
      },
      {
        path: "/fail",
        name: "fail",
        component: FormError,
        meta: {
          public: false,
        },
      },
    ],
  },
  /**
   * 404: Not Found
   */
  {
    path: "*",
    name: "NotFound",
    meta: {
      public: true,
    },
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
